<!--附近网速的入口广告位-->
<template>
    <div class="neighbors-index" v-show="adData.length">
        <div v-show="!isCloseAd">
            <div v-if="source===2" ref="googleIndexAdLeft" class="google-index-activity-left">
                <ins class="adsbygoogle"
                     style="display:inline-block;width:1114px;height:200px;"
                     :data-ad-client="googleDataAdClient"
                     :data-ad-slot="googleDataAdSlot"
                     ref="googleIndexAdIns"
                ></ins>
            </div>
            <div class="neighbors-index-content" v-if="source===1||source===3||source===6">
                <img @click="openAdDetail" class="speed-activity-img-left" v-if="imgSrc" :src="imgSrc" alt="icon"/>
            </div>
            <!--百度广告-->
            <div v-if="source===4" ref="baiduIndexAdLeft" :class="`${baiduAdContainer} baidu-index-ad-left`"></div>
        </div>
    </div>
</template>

<script>
import pubAdMixins from "../../mixin/pubAdMixins";

export default {
    name: "AdNeighbors",
    mixins: [pubAdMixins],

}
</script>

<style scoped lang="scss">
.neighbors-index {
    width: 1114px;
    height: 200px;
    margin: 0 auto;

}

.neighbors-index-content {
    img {
        width: 100%;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/ads/AdNeighbors.vue